export const NEXT_LINE_OFFSET = 10;
